import {
    GET_MERCHANT_PAYMENT_FILE_LIST,
    GET_MERCHANT_PAYMENT_FILE_LIST_SUCCESS,
    GET_MERCHANT_PAYMENT_FILE_SEARCH,
    GET_MERCHANT_PAYMENT_FILE_SEARCH_SUCCESS,
    GET_MERCHANT_PAYMENT_DETAIL_LIST,
    GET_MERCHANT_PAYMENT_DETAIL_LIST_SUCCESS,
    MERCHANT_PAYMENT_FILE_API_ERROR
} from "./actionTypes"

export const getMerchantPaymentFileList = record => ({
    type: GET_MERCHANT_PAYMENT_FILE_LIST,
    payload: record
})

export const getMerchantPaymentFileListSuccess = record => ({
    type: GET_MERCHANT_PAYMENT_FILE_LIST_SUCCESS,
    payload: record
})

export const getMerchantPaymentFileSearch = record => ({
    type: GET_MERCHANT_PAYMENT_FILE_SEARCH,
    payload: record,
})
export const getMerchantPaymentFileSearchSuccess = record => ({
    type: GET_MERCHANT_PAYMENT_FILE_SEARCH_SUCCESS,
    payload: record,
})

export const getMerchantPaymentDetailList = guid => ({
    type: GET_MERCHANT_PAYMENT_DETAIL_LIST,
    payload: guid
})

export const getMerchantPaymentDetailListSuccess = record => ({
    type: GET_MERCHANT_PAYMENT_DETAIL_LIST_SUCCESS,
    payload: record
})


export const merchantPaymentFileApiError = error => {
    return {
        type: MERCHANT_PAYMENT_FILE_API_ERROR,
        payload: error,
    }
}
